import React from "react";

import { connect } from "react-redux";
import { updateTabValue, updateCategoryData } from "../Redux/actions";

import DataNotFound from "../Util/DataNotFound/DataNotFound";
import SkeletonLoader from "../Util/SkeletonLoader/SkeletonLoader";
import Footer from "../Util/Footer/Footer";
import BaseUrl from "../Util/BaseUrl";
import ApiSuffix from "../Util/ApiSuffix";

import StarsRoundedIcon from "@material-ui/icons/StarsRounded";
import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Button from "@material-ui/core/Button";
import ArrowUpwardRoundedIcon from "@material-ui/icons/ArrowUpwardRounded";
import ArrowDownwardRoundedIcon from "@material-ui/icons/ArrowDownwardRounded";
import "./Category.css";

import ReactGA from "react-ga";

class Category extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      fetchError: false,
      categoryData: {},
      products: [],
    };

    this.baseUrl = BaseUrl;
    this.apiSuffix = ApiSuffix;
  }

  componentDidMount = () => {
    this.props.updateTabValue("/catalogue");
    this.pingAnaltyics(this.props.match.params.name);
    if (
      this.props.authStore.activeCategoryData &&
      this.props.authStore.activeCategoryData.categoryName ===
        this.props.match.params.name
    ) {
      this.setState({ loading: false });
    } else {
      this.getCategoryData();
    }
  };

  getCategoryData = () => {
    this.setState({ loading: true });
    const url =
      this.baseUrl.dev +
      this.apiSuffix.getCategoryDetails +
      this.props.match.params.name +
      "/";
    fetch(url, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw Error(response.statusText);
        }
        return response.json();
      })
      .then((data) => {
        this.props.updateCategoryData(data);
        this.setState({
          loading: false,
          fetchError: false,
        });
        data.categoryName = this.props.match.params.name;
        this.setProductContent(data.categoryTags);
        this.sendSeoData(data);
      })
      .catch((error) => {
        console.error("Error:", error);
        this.setState({ loading: false, fetchError: true });
      });
  };

  setProductContent = (tags) => {
    document.getElementById("content").innerHTML = tags;
  };

  pingAnaltyics(category) {
    ReactGA.initialize("UA-162083606-1");
    ReactGA.pageview("Category-" + category);
  }

  sendSeoData = (data) => {
    document.title =
      "Shop | Buy " +
      data.categoryName +
      " online | " +
      data.categoryName +
      " delivery in lucknow near me";
    let metaD = document.getElementsByName("description");
    metaD[0].content = data.categoryDescription;
    let structuredData = JSON.stringify({
      "@context": "http://schema.org",
      "@type": "Restaurant",
      name: "Brijwasi Bakery",
      image: window.location.origin + "/sq-min.jpg",
      telephone: ["8808011133"],
      email: "care@brijwasibakery.com",
      geo: {
        "@type": "GeoCoordinates",
        latitude: 26.8154475,
        longitude: 80.8997406,
      },
      address: {
        "@type": "PostalAddress",
        streetAddress: "17, 18 Talkatora Road",
        addressLocality: "Alambagh",
        addressRegion: "Lucknow",
        postalCode: "226005",
        addressCountry: "India",
      },
      openingHoursSpecification: [
        {
          "@type": "OpeningHoursSpecification",
          dayOfWeek: [
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday",
            "Sunday",
          ],
          opens: "10:00",
          closes: "22:00",
        },
      ],
      menu: window.location.origin + "/catalogue",
      url: "https://www.brijwasibakery.com/",
    });
    let el = document.getElementById("brand-json");
    if (el) {
      el.remove();
    }
    let el2 = document.getElementById("product-json");
    if (el2) {
      el2.remove();
    }
    const script = document.createElement("script");
    script.setAttribute("type", "application/ld+json");
    script.setAttribute("id", "brand-json");
    script.textContent = structuredData;
    document.head.appendChild(script);
  };

  gotoProduct = (item, subCategory) => {
    let url =
      "/shop/" + this.props.match.params.name + "/" + item.productDisplayURL;
    this.props.history.push(url);
  };

  displayCategory = (id) => {
    let el = document.getElementById(id);
    el.scrollIntoView({
      behavior: "smooth",
      block: "nearest",
      inline: "nearest",
    });
  };

  scrollToTop = () => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  };

  onAddClick = (e, item) => {
    this.gotoProduct(item);
  };

  render = () => {
    return (
      <div className="base-container">
        {this.state.loading ? (
          <SkeletonLoader />
        ) : this.state.fetchError ? (
          <DataNotFound history={this.props.history} />
        ) : (
          <div>
            <h2 className="category-caption">
              {this.props.authStore.activeCategoryData.categoryName}
            </h2>
            <div className="tag-container">
              {this.props.authStore.activeCategoryData.subCategory.map(
                (subCat, index) => (
                  <Button
                    color="primary"
                    variant="contained"
                    key={index}
                    onClick={(e) => this.displayCategory(subCat.subCategoryID)}
                    className="tag-button"
                    style={{ padding: "5px" }}
                  >
                    <ArrowDownwardRoundedIcon /> {subCat.subCategoryName}
                  </Button>
                )
              )}
            </div>
            <div className="products-container">
              {this.props.authStore.activeCategoryData.subCategory &&
              this.props.authStore.activeCategoryData.subCategory.length > 0 ? (
                <div>
                  {this.props.authStore.activeCategoryData.subCategory.map(
                    (subCat, i1) => (
                      <ExpansionPanel
                        key={i1}
                        defaultExpanded={true}
                        style={{ background: "#eee" }}
                        id={subCat.subCategoryID}
                      >
                        <ExpansionPanelSummary
                          expandIcon={<ExpandMoreIcon />}
                          aria-controls="category-content"
                          id="category-header"
                        >
                          <h3 className="products-cat-caption">
                            {subCat.subCategoryName}
                          </h3>
                        </ExpansionPanelSummary>
                        <ExpansionPanelDetails style={{ padding: "5px" }}>
                          <div style={{ textAlign: "center", width: "100%" }}>
                            <div className="products-wrapper">
                              {subCat.products.map((product, i2) => (
                                <div
                                  key={i2}
                                  className="product-cat-wrapper"
                                  onClick={(e) =>
                                    this.gotoProduct(product, subCat)
                                  }
                                >
                                  {product.productDiscount > 0 &&
                                  !product.isOutOfStock ? (
                                    <div
                                      className="featured-tag"
                                      style={{ fontWeight: "bold" }}
                                    >
                                      {product.productDiscount}% Off
                                    </div>
                                  ) : null}
                                  {product.isOutOfStock ? (
                                    <div className="featured-tag">
                                      Out of Stock
                                    </div>
                                  ) : null}
                                  <div style={{ width: "150px" }}>
                                    <img
                                      className="image-loader-loaded"
                                      alt={product.productName}
                                      src={
                                        product.productImageURL50
                                          ? product.productImageURL50
                                          : product.productImageURL
                                      }
                                      loading="lazy"
                                    />
                                  </div>
                                  <div className="product-side-div">
                                    <h4 className="product-name">
                                      {product.productName}
                                      {product.isFeatured ? (
                                        <span>
                                          <StarsRoundedIcon
                                            style={{
                                              fill: "#ffb300",
                                              width: "1.5rem",
                                            }}
                                          />
                                        </span>
                                      ) : null}
                                    </h4>
                                    {product.outsideLucknowDelivery ? (
                                      <span className="pan-tag">
                                        Nation wide Delivery
                                      </span>
                                    ) : null}
                                    {product.variants &&
                                    product.variants.length > 0 &&
                                    product.variants[0].productPrice ? (
                                      <div style={{ marginTop: "10px" }}>
                                        <span className="rate-tag">
                                          Starts from Rs.
                                          {product.variants[0].productPrice}
                                        </span>
                                      </div>
                                    ) : null}
                                    <Button
                                      color="primary"
                                      variant="contained"
                                      className="add-button"
                                      onClick={(e) =>
                                        this.onAddClick(e, product)
                                      }
                                    >
                                      <span className="font-monst-bold">
                                        {" "}
                                        + ADD
                                      </span>
                                    </Button>
                                  </div>
                                </div>
                              ))}
                            </div>
                            <Button
                              color="primary"
                              variant="contained"
                              className="tag-button"
                              onClick={(e) => this.scrollToTop()}
                            >
                              <ArrowUpwardRoundedIcon /> Go To Top
                            </Button>
                          </div>
                        </ExpansionPanelDetails>
                      </ExpansionPanel>
                    )
                  )}
                  <h3 className="category-description">
                    {
                      this.props.authStore.activeCategoryData
                        .categoryDescription
                    }
                  </h3>
                  <div>
                    <hr />
                    <div id="content"></div>
                    <hr />
                  </div>
                </div>
              ) : (
                <DataNotFound history={this.props.history} />
              )}
            </div>
          </div>
        )}
        <Footer />
      </div>
    );
  };
}

const mapStateToProps = (state) => ({
  cartStore: state.cartStore,
  authStore: state.authStore,
});

const mapDispatchToProps = (dispatch) => ({
  updateTabValue: (tabValue) => dispatch(updateTabValue(tabValue)),
  updateCategoryData: (catData) => dispatch(updateCategoryData(catData)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Category);
